const CITIES_LIST = ["Москва", "Санкт-Петербург"];
const FREE_DELIVERY_LIMIT = 1000000;

export { CITIES_LIST, FREE_DELIVERY_LIMIT };
